import CheckPromotion from './CheckPromotion'
import { connect } from 'react-redux'
import { withTranslation } from "react-i18next";
import * as promotionActions from './../../../../actions/promotionAction';

const mapStateToProps = state => {
    return {
        promotionState: state.promotionReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        checkPromotion: code => dispatch(promotionActions.checkPromotion(code)),
        resetDataCheck: () => dispatch(promotionActions.resetDataCheck())
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(CheckPromotion));